import React from 'react'
import { withRouter } from 'react-router-dom'

import ActionButton from './ActionButton'

function CreateButton(props) {
  const _props = { ...props }

  if (_props.path) _props.onClick = _ => _props.history.push(_props.path)

  return <ActionButton {..._props} />
}

CreateButton.defaultProps = {
  content: 'Crear',
  compact: false,
  color: 'blue',
  size: 'small',
}

export default withRouter(CreateButton)
